import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Logo } from '../Logo';
import styles from './Header.css';

const cx = classnames.bind(styles);

function Header({ className, renderLeftNavigation, url, finished }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <header className={classes}>
            <div className={styles.wrapper}>
                <Logo url={url} className={cx({ logo: true, finished })} />
                {Boolean(renderLeftNavigation) && renderLeftNavigation()}
            </div>
        </header>
    );
}

Header.propTypes = {
    className: PropTypes.string,
    renderLeftNavigation: PropTypes.func,
    url: PropTypes.string.isRequired,
    finished: PropTypes.bool.isRequired
};

Header.defaultProps = {
    className: '',
    renderLeftNavigation: null
};

export {
    Header
};
